module.exports = __webpack_public_path__ + "static/media/index-shop-1.d234b1f7.webp";